import { render, staticRenderFns } from "./productYZneed.vue?vue&type=template&id=81e7879e&scoped=true"
import script from "./productYZneed.vue?vue&type=script&lang=js"
export * from "./productYZneed.vue?vue&type=script&lang=js"
import style0 from "./productYZneed.vue?vue&type=style&index=0&id=81e7879e&prod&lang=css"
import style1 from "./productYZneed.vue?vue&type=style&index=1&id=81e7879e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e7879e",
  null
  
)

export default component.exports